import { Component } from '@angular/core';
import { PopUpService } from '../../services/popup.service';

@Component({
    selector: 'app-pop-up',
    styleUrls: ['popup.scss'],
    templateUrl: './popup.component.html'
})

export class PopUpComponent {
    constructor(public popUpService : PopUpService) { }
}
